import { EMAIL_TYPES, PDF_TYPES, TEMPLATE_GROUPS, type BuilderKind } from './types';

/** `?group=&type=` on the builders: which template they open on. Anything else is ignored. */
export interface BuilderSearch {
  group?: string;
  type?: string;
}

/** Call from the route's own annotated `validateSearch` (see `agreement-type-search.ts`). */
export function parseBuilderSearch(
  search: Record<string, unknown>,
  kind: BuilderKind,
): BuilderSearch {
  const types: readonly string[] = kind === 'email' ? EMAIL_TYPES : PDF_TYPES;
  const group = search['group'];
  const type = search['type'];
  // Both keys always, `undefined` when unknown: a key left out would keep the raw value, since
  // the router merges the parent routes' (unvalidated) search under this one.
  return {
    group:
      typeof group === 'string' && (TEMPLATE_GROUPS as readonly string[]).includes(group)
        ? group
        : undefined,
    type: typeof type === 'string' && types.includes(type) ? type : undefined,
  };
}
